module.exports = __webpack_public_path__ + "static/media/tauko.c6deb72e.ogg";